import React, { useState, useEffect, useRef } from 'react';
import { calculateAge, scrollToTop } from '../../../utils/helpers';
import { useDispatch, useSelector } from 'react-redux';
import BasicInfoSection from './BasicInfoSection';
// import ReligiousBackgroundSection from './ReligiousBackgroundSection';
// import FamilyDetailsSection from './FamilyDetailsSection';
// import EducationCareerSection from './EducationCareerSection';
// import HobbiesSection from './HobbiesSection';

const AboutMyself = ({ isEditing, onEditClick, onSaveClick, onCancelClick, onDataChange, updatedData }) => {
  const { userInfo } = useSelector(state => state.user);
  const familyDetails = userInfo?.family_details ? typeof userInfo?.family_details === 'string' ? JSON.parse(userInfo?.family_details): userInfo?.family_details:{mother:"",father:"",sisters:"",brothers:""};
  const hobbies = typeof userInfo?.hobbies === 'string'  ? JSON.parse(userInfo?.hobbies) : userInfo?.hobbies;
  const [selectedHobbies, setSelectedHobbies] = useState(hobbies || []);
  const [editingFields, setEditingFields] = useState("");

  // ------------------------------------------------------------
  // Cancel handling
  // ------------------------------------------------------------
  // The values shown in the section come from `updatedData` (the unsaved
  // draft) first, then from userInfo. Cancel only switched editing off, so the
  // draft stayed in `updatedData` and kept being displayed — it looked saved
  // even though the API was never called (and a later Save would have sent it).
  //
  // handleCancel discards the draft: it calls the parent's onCancelClick, then
  // sets every edited field back to its original value, one field per render
  // (so it also works if the parent's onDataChange isn't safe to call several
  // times in a row). If the parent already clears updatedData, the loop below
  // finds nothing to revert and stops immediately.
  const [resetPending, setResetPending] = useState(false);
  const revertedKeys = useRef(new Set());

  const originalFor = (field) => {
    if (field === 'hobbies') return hobbies || [];
    if (field === 'family_details') return familyDetails;
    const value = userInfo?.[field];
    return value === null || value === undefined ? "" : value;
  };

  const sameValue = (a, b) => JSON.stringify(a) === JSON.stringify(b);

  useEffect(() => {
    if (!resetPending) return;

    const draft = updatedData || {};
    const nextKey = Object.keys(draft).find(
      (key) => !revertedKeys.current.has(key) && !sameValue(draft[key], originalFor(key))
    );

    if (!nextKey) {
      setResetPending(false);
      return;
    }

    revertedKeys.current.add(nextKey);
    onDataChange(nextKey, originalFor(nextKey));
  }, [resetPending, updatedData]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleCancel = () => {
    revertedKeys.current = new Set();
    setSelectedHobbies(hobbies || []);
    setEditingFields("");
    setResetPending(true);
    onCancelClick();
  };

  const handleCheckboxChange = (hobbyValue) => {
    if (typeof hobbyValue === 'string') {
      setSelectedHobbies(prev => {
        const newHobbies = prev.includes(hobbyValue)
          ? prev.filter(item => item !== hobbyValue)
          : [...prev, hobbyValue];
        onDataChange('hobbies', newHobbies);
        return newHobbies;
      });
    } else if (hobbyValue.target) {
      const options = Array.from(hobbyValue.target.selectedOptions).map(option => option.value);
      setSelectedHobbies(options);
      onDataChange('hobbies', options);
    }
  };

  const getValue = (field) => {
    return updatedData[field] !== undefined ? updatedData[field] : userInfo[field] || "";
  };

const getFamilyValue = (field) => {  
  // Check updatedData.family_details first, then fall back to original familyDetails
  if (updatedData.family_details && updatedData.family_details[field] !== undefined) {
    return updatedData.family_details[field];
  }
  return familyDetails[field] || "";
};

  return (
    <div>
      <div className="section-title">
        Basics & Lifestyle{" "}
        {isEditing && editingFields === "basic" ? (
          <>
            <a onClick={handleCancel} className="small float-end cursor-pointer">Cancel</a>
            <a onClick={onSaveClick} className="small float-end cursor-pointer pe-2">Save</a>
          </>
        ) : (
          <a onClick={() => { onEditClick(); setEditingFields("basic") }} className="small float-end cursor-pointer">Edit</a>
        )}
      </div>
      <BasicInfoSection 
        isEditing={isEditing} 
        getValue={getValue} 
        onDataChange={onDataChange} 
        editingFields={editingFields} 
      />


      <div className="row py-3 border-top"></div>
      <div className="text-end">
        <button type='button' onClick={scrollToTop} className="btn btn-link back-to-top">
          Back to Top <i className="fa fa-angle-up" aria-hidden="true"></i>
        </button>
      </div>
    </div>
  );
};

export default AboutMyself;